import React, { useState, useEffect, useCallback, useMemo, lazy, Suspense } from 'react';
import { Inbox, CheckCircle, XCircle } from 'lucide-react';
import Tabs from '../ui/Tabs.jsx';

// Lazy load the modern table components
const LeadsCurrentModern = lazy(() => import('../ModernTable/LeadsCurrentModern.jsx'));
const LeadsClosedModern = lazy(() => import('../ModernTable/LeadsClosedModern.jsx'));
const LeadsDeclinedModern = lazy(() => import('../ModernTable/LeadsDeclinedModern.jsx'));

const LeadsTabs = ({ onTabChange, headerActions, onEditLead, refreshTrigger }) => {
    const [leadsCounts, setLeadsCounts] = useState({ current: 0, closed: 0, declined: 0 });

    const fetchLeadsCounts = useCallback(async () => {
        try {
            const response = await fetch('index.php/leads/getNumberOfLeads');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setLeadsCounts({
                current: data.current,
                closed: data.closed,
                declined: data.declined
            });
        } catch (error) {
            console.error('Error fetching lead counts:', error);
        }
    }, []);

    useEffect(() => {
        fetchLeadsCounts();
    }, [fetchLeadsCounts]);

    const tabsData = useMemo(() => [
        {
            id: 'current',
            name: 'Aktuell',
            icon: Inbox,
            count: leadsCounts.current,
            content: (
                <Suspense fallback={<div className="text-center py-3">Laedt...</div>}>
                    <LeadsCurrentModern
                        key="current-modern"
                        updateCounts={fetchLeadsCounts}
                        onEditLead={onEditLead}
                        refreshTrigger={refreshTrigger}
                    />
                </Suspense>
            )
        },
        {
            id: 'closed',
            name: 'Angenommen',
            icon: CheckCircle,
            count: leadsCounts.closed,
            content: (
                <Suspense fallback={<div className="text-center py-3">Laedt...</div>}>
                    <LeadsClosedModern
                        key="closed-modern"
                        updateCounts={fetchLeadsCounts}
                        onEditLead={onEditLead}
                        refreshTrigger={refreshTrigger}
                    />
                </Suspense>
            )
        },
        {
            id: 'declined',
            name: 'Abgelehnt',
            icon: XCircle,
            count: leadsCounts.declined,
            content: (
                <Suspense fallback={<div className="text-center py-3">Laedt...</div>}>
                    <LeadsDeclinedModern
                        key="declined-modern"
                        updateCounts={fetchLeadsCounts}
                        onEditLead={onEditLead}
                        refreshTrigger={refreshTrigger}
                    />
                </Suspense>
            )
        },
    ], [leadsCounts, fetchLeadsCounts, onEditLead, refreshTrigger]);

    return (
        <div>
            <Tabs tabs={tabsData} onTabChange={onTabChange} headerActions={headerActions} />
        </div>
    );
};

export default LeadsTabs;
